import { BTTO_PROFILE_COLORS } from "@pages/profile-v2/betto/shared/elements";
import styled, { css } from "styled-components";

const isBetto = window.TENANT === "betto";

const BonusesWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

const BonusesCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${isBetto ? "16px" : "0"};
	width: 100%;

	${isBetto &&
	css`
		padding: 16px;
		border-radius: 12px;
		background: ${BTTO_PROFILE_COLORS.surface};
		border: 1px solid ${BTTO_PROFILE_COLORS.border};

		@media (min-width: 768px) {
			padding: 20px;
		}
	`}
`;

const BonusesContent = styled.div`
	display: flex;
	padding: ${isBetto ? "0" : "10px"};
	flex-direction: column;
	align-items: center;
	gap: 10px;
	flex: 1 0 0;
	width: 100%;
	border-radius: ${isBetto ? "0" : "20px"};
	background: ${isBetto ? "transparent" : "var(--profile-page-wrapper-bg)"};

	@media (min-width: 1024px) {
		padding: ${isBetto ? "0" : "10px 20px"};
	}
`;

const BonusesHeader = styled.div`
	display: flex;
	margin: ${isBetto ? "0" : "20px 0"};
	width: 100%;
`;

const BonusesHeaderTabs = styled.div`
	display: flex;
	gap: 10px;
	overflow-x: auto;
`;

const BonusesHeaderTab = styled.div`
	display: flex;
	height: 40px;
	max-width: 360px;
	padding: 0 15px;
	justify-content: center;
	align-items: center;
	gap: 5px;
	border-radius: ${isBetto ? "10px" : "25px"};
	color: ${isBetto ? BTTO_PROFILE_COLORS.textMuted : "#eff0f6"};
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	min-width: max-content;
	cursor: pointer;
	background: ${isBetto ? BTTO_PROFILE_COLORS.surfaceRaised : "#120507"};
	border: ${isBetto ? `1px solid ${BTTO_PROFILE_COLORS.border}` : "none"};
	transition: ${isBetto
		? "background 0.2s ease, border-color 0.2s ease, color 0.2s ease"
		: "none"};

	&:hover {
		${isBetto &&
		css`
			background: ${BTTO_PROFILE_COLORS.surfaceHover};
			border-color: ${BTTO_PROFILE_COLORS.borderActive};
			color: ${BTTO_PROFILE_COLORS.text};
		`}
	}

	${({ active }) =>
		active &&
		(isBetto
			? css`
					background: ${BTTO_PROFILE_COLORS.primary};
					border-color: ${BTTO_PROFILE_COLORS.borderActive};
					color: ${BTTO_PROFILE_COLORS.primaryText};
				`
			: css`
					background: var(--modal-input-bg);
					color: #eff0f6;
				`)}

	&:last-of-type {
		margin-right: 20px;
	}
`;

const BonusWrapper = styled.div`
	display: flex;
	flex-direction: column;
	column-gap: 10px;
	row-gap: 0;
	justify-content: center;

	@media (min-width: 768px) {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(auto, 1fr);
		column-gap: 10px;
		width: 100%;
	}
`;

export {
	BonusesCard,
	BonusesContent,
	BonusesHeader,
	BonusesHeaderTab,
	BonusesHeaderTabs,
	BonusesWrapper,
	BonusWrapper,
};
